import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ToolbarService {
  private enabledToolSubject = new BehaviorSubject<string>("none");

  public enabledTool$ = this.enabledToolSubject.asObservable();

  public enableTool(enable: string) {
    if (enable !== this.getEnableTool()) this.enabledToolSubject.next(enable);
  }

  getEnableTool(): string {
    return this.enabledToolSubject.getValue();
  }
}
